import { inject, Injectable } from "@angular/core";
import { ENV_FILE_TOKEN } from "../../../environments";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { catchError, Observable, of, shareReplay, startWith, Subject, switchMap } from "rxjs";
import { LanguageDto, TimezoneDto } from "../../dto";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  readonly #envConfig = inject(ENV_FILE_TOKEN);
  readonly #httpClient = inject(HttpClient);
  readonly #languagesUrl = `${this.#envConfig.coreServiceUrl}api/public/languages/duo`;
  readonly #timezonesUrl = `${this.#envConfig.coreServiceUrl}api/public/timezones`;
  readonly #loadLanguages$$ = new Subject<void>();
  readonly #loadTimezones$$ = new Subject<void>();

  readonly languagesLoaded: Observable<LanguageDto[]> = this.#loadLanguages$$.pipe(
    startWith(undefined),
    switchMap(() => {
      return this.#httpClient.get<LanguageDto[]>(this.#languagesUrl, { withCredentials: true }).pipe(
        catchError((response: HttpErrorResponse) => {
          console.error(response);
          return of([] as LanguageDto[]);
        })
      );
    }),
    shareReplay(1)
  );

  readonly timezonesLoaded: Observable<TimezoneDto[]> = this.#loadTimezones$$.pipe(
    startWith(undefined),
    switchMap(() => {
      return this.#httpClient.get<TimezoneDto[]>(this.#timezonesUrl, { withCredentials: true }).pipe(
        catchError((response: HttpErrorResponse) => {
          console.error(response);
          return of([] as TimezoneDto[]);
        })
      );
    }),
    shareReplay(1)
  );

  loadLanguages(): void {
    this.#loadLanguages$$.next();
  }

  loadTimezones(): void {
    this.#loadTimezones$$.next();
  }
}
